import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import CustomizedCheckbox from "commonComponents/FormElement/Checkbox";
import MailIcon from "assets/svgIcons/MailIcon";
import PrintIcon from "assets/svgIcons/PrintIcon";
import ChatIcon from "assets/svgIcons/ChatDoubleIcon";
import {
    getFeatureSetOption,
    getFeaturesList,
    isUserBasic,
    isUserReadOnly,
    isUserAdmin
} from "../../../../constant";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import {
    Heading,
    WorkSection,
    CheckBoxWrapper,
    ActionWrapper
} from "pages/Fleet/Settings/SettingsStyled";
import { Loader } from "commonComponents/Loader/Loader";
import { useHookstate } from "@hookstate/core";
import { CenteredLoader } from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import { CHECKBOX_LOADER } from "globalStore/globalStore";
import { useSelector } from "react-redux";
import { WeatherCheckbox } from "commonComponents/FormElement/Checkbox/WeatherCheckbox";
import { Button } from "@mui/material";
import "react-quill/dist/quill.snow.css";

export const ScorecardAccordion = ({ handleTextRoundManagementOnSave,
    handleTextRoundManagementOnReset,
    tempEmail,
    setTempEmail,
    roundManagement2Button,
    setRoundManagement2Button,
    isValid }) => {
    const { t } = useTranslation();

    const { scoreCardTabLoader } = useHookstate(CHECKBOX_LOADER);

    const { siteSettingsData, getUserRole } = useSelector((state) => state?.commonReducers) || [];

    return (
        <>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Heading>
                        <h3>{t("Scorecard")}</h3>
                    </Heading>
                </AccordionSummary>
                <AccordionDetails>
                    <WorkSection>
                        {scoreCardTabLoader.get() && (
                            <CenteredLoader className="innerSectionLoader">
                                <Loader />
                            </CenteredLoader>
                        )}
                        <div>
                            <CheckBoxWrapper>
                                <CustomizedCheckbox
                                    identification="SC"
                                    label={t("Scorecard")}
                                    name="Scorecard"
                                    lockdownText="scoreCards"
                                    width={15}
                                    height={15}
                                    disabled={isUserReadOnly(getUserRole?.Role)}
                                />
                                <MailIcon className="cloud-icon" />
                            </CheckBoxWrapper>
                        </div>
                        <div>
                            <CheckBoxWrapper>
                                <WeatherCheckbox
                                    identification="PS"
                                    disabledState={
                                        isUserReadOnly(getUserRole?.Role)
                                    }
                                />
                                <PrintIcon className="cloud-icon" />
                            </CheckBoxWrapper>
                        </div>
                        <div>
                            <CheckBoxWrapper>
                                <CustomizedCheckbox
                                    identification="SSC"
                                    label={t("Share_Scorecard")}
                                    name="ShareScorecard"
                                    lockdownText="shareScoreCards"
                                    width={15}
                                    height={15}
                                    disabled={isUserReadOnly(getUserRole?.Role)}
                                />
                                <ChatIcon className="cloud-icon" />
                            </CheckBoxWrapper>
                        </div>
                        <div>
                            <p className="label">{t("Scorecard_email")}</p>
                            <input
                                type="text"
                                name="scorecardEmail"
                                className="scorecard-email-input"
                                value={tempEmail}
                                onChange={(e) => {
                                    setRoundManagement2Button(true);
                                    setTempEmail(e.target.value);
                                }}
                                disabled={
                                    getFeatureSetOption(
                                        siteSettingsData && siteSettingsData?.Features,
                                        getFeaturesList().golfer_experience
                                    ) ||
                                    isUserBasic(getUserRole && getUserRole?.Role) ||
                                    isUserReadOnly(getUserRole && getUserRole?.Role)
                                }
                            />
                            <p className="p-0 mb-10">
                                <small>{isValid}</small>
                            </p>
                            <ActionWrapper>
                                <Button
                                    variant="outlined"
                                    disabled={
                                        getFeatureSetOption(
                                            siteSettingsData && siteSettingsData?.Features,
                                            getFeaturesList().golfer_experience
                                        ) ||
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                    onClick={() => handleTextRoundManagementOnSave("scorecardEmail")}
                                    className={roundManagement2Button ? "active" : "disabled"}
                                >
                                    {t("Save")}
                                </Button>
                                <Button
                                    variant="outlined"
                                    disabled={
                                        getFeatureSetOption(
                                            siteSettingsData && siteSettingsData?.Features,
                                            getFeaturesList().golfer_experience
                                        ) ||
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                    className="send-btn"
                                    onClick={() => handleTextRoundManagementOnReset("scorecardEmail")}
                                >
                                    {t("Reset")}
                                </Button>
                            </ActionWrapper>
                        </div>
                    </WorkSection>
                </AccordionDetails>
            </Accordion>
        </>
    );
};